<style lang="less" scoped>
.map {
  position: absolute;
  width: 100%;
  height: 100%;
}
.map-content {
  width: calc(100%+40px);
  height: 93vh;
  position: relative;
  margin: -20px;
}
.toLink {
  font-size: 14px;
  color: cornflowerblue;
}
/deep/ .el-main {
  padding: 0;
}
</style>
<template>
  <div>
    <div class="map-content">
      <baidu-map
        class="map"
        :center="center"
        :zoom="zoom"
        @ready="handler"
        :scroll-wheel-zoom="true"
      >
        <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
        <!-- <bm-marker
          :position="markerPoint"
          :dragging="true"
          @click="infoWindowOpen"
        >
          <bm-info-window
            :show="show"
            @close="infoWindowClose"
            @open="infoWindowOpen"
            ><a href="">我爱北京天安门</a></bm-info-window
          >
        </bm-marker>-->
        <div v-for="(marker,key) of markerPoints" :key="key">
          <bm-marker
            :position="{ lng: marker.lng, lat: marker.lat }"
            :title="marker.name"
            @click="infoWindowOpen(marker)"
            :icon="{url:icon(marker.status),size:{width:30,height:30}}"
          >
            <bm-info-window
              title="监测站信息"
              :position="{ lng: marker.lng, lat: marker.lat }"
              :show="marker.showFlag"
              @close="infoWindowClose(marker)"
              @open="infoWindowOpen(marker)"
            >
              <router-link class="toLink" :to="marker.path">{{marker.name}}</router-link>
            </bm-info-window>
          </bm-marker>
        </div>
      </baidu-map>
    </div>
  </div>
</template>

<script>
import onlineIcon from '@/assets/img/macro_online.png'; //在线icon
import offlineIcon from '@/assets/img/macro_offline.png'; //离线icon
import alertIcon from '@/assets/img/macro_alert.png'; //报警icon
export default {
  name: "index",
  data() {
    return {
      pageLoading: false, //页面loading
      center: { lng: 116.404, lat: 39.915 },
      zoom: 7,
      show: false,
      markerPoint: { lng: 116.404, lat: 39.915 },
      markerPoints: [],
      stationList: [],
      deviceIcon:''
    };
  },

  methods: {
    handler({ BMap, map }) {
      return new Promise((resolve, reject) => {
        this.$$http("automaticStation", {})
          .then((results) => {
            if (results.data && results.status == 200) {
              this.stationList = results.data.results;
              for (let i in this.stationList) {
                this.markerPoints.push({
                  lng: this.stationList[i].lng,
                  lat: this.stationList[i].lat,
                  status:this.stationList[i].status,
                  name: this.stationList[i].name,
                  path: "/automaticStation/classify/" + this.stationList[i].id,
                  showFlag: false,
                });
              }
              // console.log("stationList", this.markerPoints);
              if (this.markerPoints.length) {
                this.center.lng = this.markerPoints[0].lng;
                this.center.lat = this.markerPoints[0].lat;
                // this.deviceIcon = this.icon(this.markerPoint[0].status);
              }

              this.zoom = 9;
              resolve(results);
            } else {
              this.$message.error(
                results.data.msg ? results.data.msg : "获取自动站失败"
              );
              reject(results);
            }
          })
          .catch((err) => {});
      });
    },
    // infoWindowClose() {
    //   this.show = false;
    // },
    // infoWindowOpen() {
    //   this.show = true;
    // },
    infoWindowClose(marker) {
      marker.showFlag = false;
    },
    infoWindowOpen(marker) {
      marker.showFlag = true;
    },
    icon(status){
      switch (status) {
         case 0:
          return onlineIcon;
          break;
        case 1:
          return alertIcon;
          break;
        case 2:
          return offlineIcon;
          break;
      }
    }
  },
  created() {
    // let stationList = this.pbFunc.getLocalData('stations',true);
    // this.deviceIcon = this.icon(stationList[0].status);
    //暂时变为全部都是蓝色
    // this.deviceIcon = onlineIcon;
  },
  // watch: {
  //   markerPoint: {
  //     handler(newName, oldName) {
  //       if (oldName) {
  //          if (this.markerPoints.length) {
  //             this.deviceIcon = this.icon(this.markerPoint[0].status);

  //          }
  //       }
  //     },
  //     deep: true,
  //   },
  // },
};
</script>



// WEBPACK FOOTER //
// src/pages/index.vue